module.exports = __webpack_public_path__ + "img/hungary.7b5a2553.svg";